import { render, staticRenderFns } from "./indexWrapper.vue?vue&type=template&id=56f1d2d4&scoped=true"
import script from "./indexWrapper.vue?vue&type=script&lang=js"
export * from "./indexWrapper.vue?vue&type=script&lang=js"
import style0 from "./indexWrapper.vue?vue&type=style&index=0&id=56f1d2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f1d2d4",
  null
  
)

export default component.exports